import { useMsal } from '@azure/msal-react';
import { Claim, UserRole } from '@scts/models';
import { ReactNode, useEffect, useState } from 'react';
import { AuthContext } from './auth-context';

type Props = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: Props) => {
  const [userRole, setUserRole] = useState(UserRole.None);
  const { accounts } = useMsal();

  // interrogate msal to find out users role and make it available to the application
  useEffect(() => {
    if (accounts && accounts[0]) {
      let userType = (accounts[0].idTokenClaims as unknown as Claim)
        .extension_typeOfUser;

      // incase there is an issue getting the role from B2C (should never happen but did in PP)
      // set to some random value and the app will error properly as the token will be wrong for the api
      if (!userType) {
        userType = 'no role available';
      }

      if (userType.toLowerCase() === 'member') {
        setUserRole(UserRole.Member);
      } else {
        setUserRole(UserRole.Appellant);
      }
    }
  }, [accounts]);

  return (
    <AuthContext.Provider value={{ userRole, setUserRole }}>
      {children}
    </AuthContext.Provider>
  );
};
